import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import NotFound from './NotFound/component';
import { IAppState } from '../../../../../../state/reducers';
import { toggleNotFound } from '../../../../../../state/exchange/searchResults';

class NotFoundDialog extends PureComponent<IProps> {
  render() {
    const {
      isOpen,
      onClose,
      teamsWithoutGames,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="xs"
      >
        <NotFound
          teamsWithoutGames={teamsWithoutGames}
        />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.searchResults.notFoundOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: toggleNotFound,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotFoundDialog);
